// src/pages/CGV.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

function CGV() {
  const { t } = useTranslation();
  return (
    <main className="legal-page">
      <header className="page-hero">
        <div className="page-hero__inner">
          <span className="page-hero__label">{t('cgv.heroLabel')}</span>
          <h1 className="page-hero__title">{t('cgv.heroTitle')}</h1>
        </div>
      </header>
      <section className="legal-content">
        <h2>{t('cgv.s1Title')}</h2><p>{t('cgv.s1Text')}</p>
        <h2>{t('cgv.s2Title')}</h2><p>{t('cgv.s2Text')}</p>
        <h2>{t('cgv.s3Title')}</h2><p>{t('cgv.s3Text')}</p>
        <h2>{t('cgv.s4Title')}</h2><p>{t('cgv.s4Text')}</p>
        <h2>{t('cgv.s5Title')}</h2><p>{t('cgv.s5Text')}</p>
        <h2>{t('cgv.s6Title')}</h2><p>{t('cgv.s6Text')}</p>
        <h2>{t('cgv.s7Title')}</h2><p>{t('cgv.s7Text')}</p>
      </section>
    </main>
  );
}

export default CGV;